import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DaySelectorComponent} from './day-selector/day-selector.component';
import {SearchBarComponent} from './search-bar/search-bar.component';
import {TimePickerComponent} from './time-picker/time-picker.component';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {SharedModule} from '../../shared.module';
import {SlotTimePickerComponent} from './slot-time-picker/slot-time-picker.component';


@NgModule({
  declarations: [
    DaySelectorComponent,
    SearchBarComponent,
    TimePickerComponent,
    SlotTimePickerComponent
  ],
  exports: [
    SearchBarComponent,
    DaySelectorComponent,
    SlotTimePickerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class MwFormsModule { }
